package com.tovtalk.domain.auth

import com.tovtalk.data.local.TokenManager
import com.tovtalk.presentation.viewmodel.auth.AuthSheetController

class AuthInterceptor(
    private val tokenManager: TokenManager,
    private val authSheet: AuthSheetController,
) {
    /**
     * Run [block] only if the user has an access token.
     * Otherwise open the auth sheet and return null.
     */
    suspend fun <T> runAuthenticated(reason: String? = null, block: suspend () -> T): T? {
        return if (tokenManager.accessToken != null) {
            block()
        } else {
            authSheet.open(reason)
            null
        }
    }
}
